import { FilterOperators } from '@kirin/api-client/contracts/table';
import {
  USER_SECURITY_POSTURE_FILTERABLE_FIELDS,
  type UserSecurityPostureFilterableField,
} from '@kirin/api-client/contracts/user-security-posture';

export const USP_TABLE_CONFIG = {
  tableId: 'org-usr',
  defaultOperator: FilterOperators.INCLUDES,
} as const;

/**
 * URL key mapping for user security posture filter fields.
 * `satisfies` enforces exhaustiveness — TypeScript errors if a field lacks a key.
 */
export const USP_FILTER_URL_KEYS = {
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.NAME]: 'n',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.EMAIL]: 'em',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.PLATFORMS_COVERED]: 'pc',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.PLATFORMS_SUPPORTED]: 'ps',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.MCP_COUNT]: 'mc',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.ALERT_COUNT]: 'ac',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.LAST_ACTIVE_AT]: 'la',
  [USER_SECURITY_POSTURE_FILTERABLE_FIELDS.ENDPOINTS]: 'ep',
} as const satisfies Record<UserSecurityPostureFilterableField, string>;

/** Number of days used for the alerts lookback window in the deep link filter. */
export const ALERT_LOOKBACK_DAYS = 7;

/**
 * Email column max width (px). Without a `maxWidth` the Email column would be
 * the greedy `width: 100%` absorber under `table-auto` (see buildColumnSizeStyle)
 * and eat the width the Covered / Supported columns need (KIR-3541). Capping it
 * (EmailCell truncates + tooltips) frees that width for the badge columns.
 */
export const EMAIL_COLUMN_MAX_WIDTH = 280;

/**
 * Covered/Supported column floors (px). These columns intentionally have NO
 * maxWidth so they stay on the greedy `width: 100%` branch (see
 * buildColumnSizeStyle) and consume the freed width, rendering badges inline
 * and only collapsing to "+N" on true overflow (KIR-3541). MIN_WIDTH is the
 * floor when a user has few badges.
 */
export const COVERED_COLUMN_MIN_WIDTH = 300;
export const SUPPORTED_COLUMN_MIN_WIDTH = 180;
